import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Verantwortlicher",
    body: [
      "Verantwortlicher für die Datenverarbeitung im Zusammenhang mit der App und Web-App BriefAssist ist:",
      "cc-onlinekurse",
      "Inhaber: Claudiu Ciobotaru",
      "Gestütring 3",
      "85435 Erding",
      "Deutschland",
      "E-Mail: info@cc-onlinekurse.de",
    ],
  },
  {
    title: "2. Allgemeine Hinweise zum Datenschutz",
    body: [
      "Der Schutz Ihrer personenbezogenen Daten ist uns wichtig.",
      "Mit dieser Datenschutzerklärung informieren wir Sie darüber, welche personenbezogenen Daten bei der Nutzung von BriefAssist verarbeitet werden, zu welchen Zwecken dies geschieht und welche Rechte Ihnen nach der Datenschutz-Grundverordnung (DSGVO) zustehen.",
      "Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen.",
      "BriefAssist ermöglicht insbesondere das Hochladen, Erfassen und automatisierte Analysieren von Dokumenten. Dabei können die hochgeladenen Dokumente personenbezogene und gegebenenfalls auch besonders sensible Informationen enthalten.",
    ],
  },
  {
    title: "3. Welche Daten werden verarbeitet?",
    body: ["Bei der Nutzung von BriefAssist können insbesondere folgende Daten verarbeitet werden:"],
    subsections: [
      {
        title: "a) Registrierungs- und Kontodaten",
        intro: "Wenn Sie ein Benutzerkonto erstellen, können insbesondere folgende Daten verarbeitet werden:",
        list: [
          "Name, sofern angegeben,",
          "E-Mail-Adresse,",
          "Benutzer-ID,",
          "Login- und Authentifizierungsdaten,",
          "Informationen zum gebuchten Tarif,",
          "Zeitpunkt der Registrierung,",
          "technische Kontoinformationen.",
        ],
        after: "Diese Daten werden benötigt, um Ihr Benutzerkonto bereitzustellen und die Nutzung der App zu ermöglichen.",
      },
      {
        title: "b) Hochgeladene Dokumente",
        intro:
          "Wenn Sie ein Dokument, einen Brief, ein Foto oder eine andere Datei über BriefAssist hochladen, werden die darin enthaltenen Daten verarbeitet. Dies können beispielsweise sein:",
        list: [
          "Vor- und Nachname,",
          "Anschrift,",
          "Telefonnummer,",
          "E-Mail-Adresse,",
          "Kundennummern,",
          "Aktenzeichen,",
          "Vertragsnummern,",
          "Rechnungsdaten,",
          "Zahlungsinformationen,",
          "Bankinformationen,",
          "Versicherungsinformationen,",
          "Angaben zu Behördenverfahren,",
          "Vertragsinformationen,",
          "Daten über andere Personen.",
        ],
        after:
          "Abhängig vom hochgeladenen Dokument können auch besonders schutzwürdige personenbezogene Daten enthalten sein. Der Nutzer sollte daher nur Dokumente hochladen, deren Verarbeitung für die Nutzung von BriefAssist erforderlich ist.",
      },
    ],
  },
  {
    title: "4. Zweck der Dokumentenverarbeitung",
    body: [
      "Die Verarbeitung hochgeladener Dokumente erfolgt zur Bereitstellung der Funktionen von BriefAssist.",
      "Dazu können insbesondere gehören:",
    ],
    list: [
      "Erkennung des Dokumenteninhalts,",
      "Texterkennung aus Fotos oder PDF-Dateien,",
      "Extraktion wichtiger Informationen,",
      "Zusammenfassung des Inhalts,",
      "verständliche Erklärung des Dokuments,",
      "Übersetzung beziehungsweise Erklärung in anderen Sprachen,",
      "Erkennung von Fristen,",
      "Erkennung von Geldbeträgen,",
      "Erkennung wichtiger Handlungsanforderungen,",
      "Erstellung von Hinweisen zu möglichen nächsten Schritten.",
    ],
    footer: [
      "Die Dokumente werden ausschließlich verarbeitet, soweit dies für die Bereitstellung der vom Nutzer angeforderten Funktionen erforderlich ist.",
    ],
  },
  {
    title: "5. Einsatz künstlicher Intelligenz",
    body: [
      "BriefAssist verwendet automatisierte Verfahren und kann dabei Technologien der künstlichen Intelligenz einsetzen.",
      "Dabei können Inhalte aus hochgeladenen Dokumenten automatisiert analysiert werden.",
      "Die künstliche Intelligenz kann beispielsweise dazu verwendet werden:",
    ],
    list: [
      "Dokumente zu verstehen,",
      "Inhalte zusammenzufassen,",
      "Informationen zu strukturieren,",
      "Texte zu übersetzen,",
      "komplizierte Formulierungen verständlicher zu erklären,",
      "relevante Fristen oder Handlungspflichten zu erkennen.",
    ],
    footer: [
      "Die Ergebnisse einer KI-basierten Analyse können Fehler enthalten.",
      "BriefAssist trifft grundsätzlich keine rechtsverbindlichen Entscheidungen über den Nutzer.",
      "Die von BriefAssist erzeugten Ergebnisse dienen ausschließlich der Unterstützung des Nutzers beim Verständnis seiner Dokumente.",
    ],
  },
  {
    title: "6. Keine Verwendung hochgeladener Dokumente für eigene Werbezwecke",
    body: [
      "Die Inhalte hochgeladener Dokumente werden nicht verwendet, um dem Nutzer personalisierte Werbung auf Grundlage des Dokumenteninhalts anzuzeigen.",
      "Eine Weitergabe oder ein Verkauf der Inhalte hochgeladener Dokumente zu Werbezwecken erfolgt nicht.",
    ],
  },
  {
    title: "7. Rechtsgrundlagen der Verarbeitung",
    body: [
      "Die Verarbeitung personenbezogener Daten erfolgt abhängig vom jeweiligen Verarbeitungsvorgang insbesondere auf Grundlage folgender Vorschriften:",
    ],
    definitions: [
      {
        term: "Art. 6 Abs. 1 lit. b DSGVO",
        text: "soweit die Verarbeitung zur Bereitstellung von BriefAssist und zur Durchführung eines Vertrags oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist.",
      },
      {
        term: "Art. 6 Abs. 1 lit. c DSGVO",
        text: "soweit die Verarbeitung zur Erfüllung gesetzlicher Verpflichtungen erforderlich ist.",
      },
      {
        term: "Art. 6 Abs. 1 lit. f DSGVO",
        text: "soweit die Verarbeitung zur Wahrung berechtigter Interessen erforderlich ist, beispielsweise zur Sicherstellung der technischen Sicherheit und zur Verhinderung von Missbrauch.",
      },
      {
        term: "Art. 6 Abs. 1 lit. a DSGVO",
        text: "soweit Sie ausdrücklich in eine bestimmte Datenverarbeitung eingewilligt haben.",
      },
    ],
    footer: ["Eine erteilte Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden."],
  },
  {
    title: "8. Besondere Kategorien personenbezogener Daten",
    body: [
      "Hochgeladene Dokumente können möglicherweise besondere Kategorien personenbezogener Daten im Sinne von Art. 9 DSGVO enthalten.",
      "Hierzu können beispielsweise Informationen gehören über:",
    ],
    list: [
      "Gesundheit,",
      "Gewerkschaftszugehörigkeit,",
      "religiöse oder weltanschauliche Überzeugungen,",
      "politische Meinungen,",
      "genetische oder biometrische Daten,",
      "das Sexualleben oder die sexuelle Orientierung.",
    ],
    footer: [
      "Sofern solche Daten verarbeitet werden, erfolgt die Verarbeitung nur, soweit hierfür eine zulässige Rechtsgrundlage nach der DSGVO besteht.",
      "Nutzer werden gebeten, nur solche personenbezogenen Daten hochzuladen, die für die gewünschte Dokumentenanalyse erforderlich sind.",
    ],
  },
  {
    title: "9. Daten anderer Personen",
    body: [
      "Dokumente können personenbezogene Daten von Personen enthalten, die nicht selbst Nutzer von BriefAssist sind.",
      "Der Nutzer ist dafür verantwortlich, dass er berechtigt ist, die jeweiligen Dokumente beziehungsweise darin enthaltenen personenbezogenen Daten über BriefAssist verarbeiten zu lassen.",
      "Dokumente sollten nicht hochgeladen werden, wenn deren Verarbeitung gegen gesetzliche Bestimmungen oder Rechte Dritter verstößt.",
    ],
  },
  {
    title: "10. Speicherung hochgeladener Dokumente",
    body: [
      "Hochgeladene Dokumente werden grundsätzlich nur so lange gespeichert, wie dies für die Bereitstellung der jeweiligen Funktion und gegebenenfalls für die vom Nutzer gewünschte weitere Nutzung erforderlich ist.",
      "Soweit BriefAssist eine Funktion zum Speichern oder erneuten Abrufen von Dokumenten anbietet, können Dokumente innerhalb des Benutzerkontos gespeichert werden.",
      "Der Nutzer kann gespeicherte Dokumente im Rahmen der innerhalb der App angebotenen Funktionen löschen.",
      "Nach einer Löschung können Daten noch für einen begrenzten Zeitraum in technischen Sicherungssystemen vorhanden sein, bevor sie endgültig gelöscht beziehungsweise überschrieben werden.",
      "Gesetzliche Aufbewahrungspflichten bleiben unberührt.",
    ],
  },
  {
    title: "11. Nutzerkonto und Löschung des Kontos",
    body: [
      "Nutzer können die Löschung ihres Benutzerkontos verlangen.",
      "Eine Anfrage kann insbesondere an folgende E-Mail-Adresse gerichtet werden:",
      "info@cc-onlinekurse.de",
      "Soweit innerhalb der App eine Funktion zur Kontolöschung angeboten wird, kann die Löschung auch unmittelbar darüber veranlasst werden.",
      "Nach Löschung des Benutzerkontos werden die damit verbundenen personenbezogenen Daten gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten oder sonstigen zulässigen Gründe für eine weitere Speicherung bestehen.",
    ],
  },
  {
    title: "12. Zahlungsabwicklung über Stripe",
    body: [
      "Für kostenpflichtige Leistungen und Abonnements kann BriefAssist den Zahlungsdienstleister Stripe einsetzen.",
      "Im Rahmen einer Zahlung können insbesondere folgende Daten verarbeitet werden:",
    ],
    list: [
      "Name,",
      "E-Mail-Adresse,",
      "Rechnungsinformationen,",
      "Zahlungsbetrag,",
      "Zahlungsstatus,",
      "verwendete Zahlungsmethode,",
      "gegebenenfalls Kreditkarten- oder Bankinformationen.",
    ],
    footer: [
      "Bestimmte Zahlungsdaten werden unmittelbar durch Stripe verarbeitet und nicht vollständig auf unseren eigenen Systemen gespeichert.",
      "Die Datenverarbeitung erfolgt insbesondere zur Durchführung des Vertrags gemäß Art. 6 Abs. 1 lit. b DSGVO sowie zur Erfüllung gesetzlicher Verpflichtungen gemäß Art. 6 Abs. 1 lit. c DSGVO.",
      "Für bestimmte Datenverarbeitungen handelt Stripe eigenständig datenschutzrechtlich verantwortlich.",
      "Weitere Informationen ergeben sich aus den Datenschutzinformationen von Stripe.",
    ],
  },
  {
    title: "13. Technische Daten und Server-Logfiles",
    body: [
      "Bei der Nutzung von BriefAssist können automatisch technische Informationen verarbeitet werden.",
      "Hierzu können gehören:",
    ],
    list: [
      "IP-Adresse,",
      "Datum und Uhrzeit des Zugriffs,",
      "Gerätetyp,",
      "Betriebssystem,",
      "Browsertyp und Browserversion,",
      "aufgerufene Funktionen,",
      "Fehlermeldungen,",
      "technische Protokolldaten.",
    ],
    afterList: "Diese Verarbeitung erfolgt insbesondere zur:",
    list2: [
      "Bereitstellung der App,",
      "Sicherstellung der technischen Stabilität,",
      "Fehleranalyse,",
      "Erkennung von Angriffen und Missbrauch,",
      "Gewährleistung der IT-Sicherheit.",
    ],
    footer: [
      "Rechtsgrundlage hierfür ist insbesondere Art. 6 Abs. 1 lit. f DSGVO.",
      "Unser berechtigtes Interesse besteht in einem sicheren und technisch zuverlässigen Betrieb von BriefAssist.",
    ],
  },
  {
    title: "14. Hosting und technische Dienstleister",
    body: [
      "Für den Betrieb von BriefAssist können externe technische Dienstleister eingesetzt werden.",
      "Hierzu können insbesondere gehören:",
    ],
    list: [
      "Hosting-Anbieter,",
      "Datenbankanbieter,",
      "Cloud-Dienstleister,",
      "KI-Dienstleister,",
      "E-Mail-Dienstleister,",
      "Zahlungsdienstleister,",
      "technische Analyse- und Fehlerdiagnosedienste.",
    ],
    footer: [
      "Soweit diese Anbieter personenbezogene Daten in unserem Auftrag verarbeiten, werden sie entsprechend den datenschutzrechtlichen Anforderungen eingebunden.",
      "Soweit erforderlich, werden Vereinbarungen zur Auftragsverarbeitung gemäß Art. 28 DSGVO abgeschlossen.",
    ],
  },
  {
    title: "15. Übermittlung von Daten in Drittländer",
    body: [
      "Bei der Nutzung bestimmter technischer Dienstleister kann nicht ausgeschlossen werden, dass personenbezogene Daten außerhalb der Europäischen Union beziehungsweise des Europäischen Wirtschaftsraums verarbeitet werden.",
      "Eine solche Übermittlung erfolgt nur, wenn die gesetzlichen Voraussetzungen der Art. 44 ff. DSGVO erfüllt sind.",
      "Hierzu können insbesondere gehören:",
    ],
    list: [
      "ein Angemessenheitsbeschluss der Europäischen Kommission,",
      "geeignete Garantien,",
      "EU-Standardvertragsklauseln,",
      "sonstige gesetzlich vorgesehene Übermittlungsmechanismen.",
    ],
  },
  {
    title: "16. Cookies und ähnliche Technologien",
    body: [
      "BriefAssist kann Cookies oder vergleichbare Technologien verwenden.",
      "Technisch notwendige Cookies beziehungsweise Speichertechnologien können eingesetzt werden, um beispielsweise:",
    ],
    list: [
      "Nutzer eingeloggt zu halten,",
      "Spracheinstellungen zu speichern,",
      "Sicherheitsfunktionen bereitzustellen,",
      "die Funktionsfähigkeit der App zu gewährleisten.",
    ],
    footer: [
      "Technisch nicht notwendige Cookies oder Tracking-Technologien werden nur eingesetzt, soweit hierfür eine erforderliche Einwilligung vorliegt.",
      "Eine erteilte Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden.",
    ],
  },
  {
    title: "17. E-Mail-Kommunikation",
    body: [
      "Wenn Sie per E-Mail Kontakt mit uns aufnehmen, werden die von Ihnen übermittelten Informationen verarbeitet.",
      "Dies betrifft insbesondere:",
    ],
    list: [
      "E-Mail-Adresse,",
      "Name, sofern angegeben,",
      "Inhalt Ihrer Nachricht,",
      "gegebenenfalls übermittelte Dateien und Dokumente.",
    ],
    footer: [
      "Die Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage.",
      "Je nach Inhalt der Anfrage erfolgt die Verarbeitung insbesondere auf Grundlage von Art. 6 Abs. 1 lit. b oder Art. 6 Abs. 1 lit. f DSGVO.",
    ],
  },
  {
    title: "18. Sicherheit der Daten",
    body: ["Wir treffen angemessene technische und organisatorische Maßnahmen, um personenbezogene Daten vor:"],
    list: ["Verlust,", "Manipulation,", "unbefugtem Zugriff,", "unbefugter Offenlegung,", "Zerstörung"],
    footer: [
      "zu schützen.",
      "Dabei werden insbesondere der Stand der Technik, Art und Umfang der Verarbeitung sowie die mit der Verarbeitung verbundenen Risiken berücksichtigt.",
      "Die Datenübertragung zwischen dem Endgerät des Nutzers und BriefAssist soll grundsätzlich verschlüsselt erfolgen.",
    ],
  },
  {
    title: "19. Speicherdauer",
    body: [
      "Personenbezogene Daten werden grundsätzlich nur so lange gespeichert, wie dies für den jeweiligen Verarbeitungszweck erforderlich ist.",
      "Darüber hinaus können Daten gespeichert werden, wenn gesetzliche Aufbewahrungsfristen bestehen.",
      "Nach Wegfall des Verarbeitungszwecks beziehungsweise nach Ablauf gesetzlicher Aufbewahrungsfristen werden die Daten gelöscht, soweit keine andere gesetzliche Rechtsgrundlage für eine weitere Speicherung besteht.",
    ],
  },
  {
    title: "20. Rechte der betroffenen Personen",
    body: ["Sie haben im Rahmen der gesetzlichen Voraussetzungen insbesondere folgende Rechte:"],
    definitions: [
      {
        term: "Recht auf Auskunft",
        text: "Sie haben gemäß Art. 15 DSGVO das Recht, Auskunft darüber zu verlangen, welche personenbezogenen Daten über Sie verarbeitet werden.",
      },
      {
        term: "Recht auf Berichtigung",
        text: "Sie können gemäß Art. 16 DSGVO die Berichtigung unrichtiger oder die Vervollständigung unvollständiger personenbezogener Daten verlangen.",
      },
      {
        term: "Recht auf Löschung",
        text: "Sie können gemäß Art. 17 DSGVO unter den gesetzlichen Voraussetzungen die Löschung Ihrer personenbezogenen Daten verlangen.",
      },
      {
        term: "Recht auf Einschränkung der Verarbeitung",
        text: "Sie können gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen.",
      },
      {
        term: "Recht auf Datenübertragbarkeit",
        text: "Sie haben unter den Voraussetzungen des Art. 20 DSGVO das Recht, die von Ihnen bereitgestellten personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.",
      },
      {
        term: "Widerspruchsrecht",
        text: "Soweit eine Verarbeitung auf Art. 6 Abs. 1 lit. e oder lit. f DSGVO beruht, können Sie gemäß Art. 21 DSGVO aus Gründen, die sich aus Ihrer besonderen Situation ergeben, Widerspruch gegen die Verarbeitung einlegen.",
      },
      {
        term: "Widerruf einer Einwilligung",
        text: "Eine erteilte Einwilligung können Sie jederzeit mit Wirkung für die Zukunft widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt hiervon unberührt.",
      },
    ],
  },
  {
    title: "21. Ausübung Ihrer Datenschutzrechte",
    body: [
      "Zur Ausübung Ihrer Datenschutzrechte können Sie sich an uns wenden:",
      "cc-onlinekurse",
      "Inhaber: Claudiu Ciobotaru",
      "Gestütring 3",
      "85435 Erding",
      "Deutschland",
      "E-Mail: info@cc-onlinekurse.de",
    ],
  },
  {
    title: "22. Beschwerderecht bei einer Datenschutzaufsichtsbehörde",
    body: [
      "Sie haben gemäß Art. 77 DSGVO das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt.",
      "Sie können sich insbesondere an die für unseren Unternehmenssitz zuständige Datenschutzaufsichtsbehörde oder an eine Datenschutzaufsichtsbehörde an Ihrem Wohnort wenden.",
    ],
  },
  {
    title: "23. Automatisierte Entscheidungsfindung",
    body: [
      "BriefAssist verwendet automatisierte Systeme zur Analyse und Erklärung von Dokumenten.",
      "Eine ausschließlich automatisierte Entscheidungsfindung mit rechtlicher Wirkung oder einer vergleichbar erheblichen Beeinträchtigung des Nutzers im Sinne von Art. 22 DSGVO findet grundsätzlich nicht statt.",
      "Die Ergebnisse der Dokumentenanalyse dienen als Informations- und Unterstützungssystem.",
    ],
  },
  {
    title: "24. Änderungen dieser Datenschutzerklärung",
    body: ["Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich:"],
    list: [
      "gesetzliche Anforderungen,",
      "technische Funktionen,",
      "eingesetzte Dienstleister,",
      "Verarbeitungsprozesse",
    ],
    footer: ["ändern.", "Es gilt die jeweils innerhalb von BriefAssist veröffentlichte aktuelle Version."],
  },
];

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="px-5 pt-4 pb-8" data-testid="privacy-page">
      <button
        onClick={() => navigate(-1)}
        data-testid="privacy-back"
        className="text-slate-600 flex items-center gap-1 text-sm mb-3"
      >
        <ArrowLeft className="w-4 h-4" /> Zurück
      </button>

      <h1 className="text-2xl font-bold text-slate-900">Datenschutzerklärung</h1>
      <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold mt-1">
        für BriefAssist
      </p>

      {SECTIONS.map((s, i) => (
        <section
          key={i}
          className="mt-5 rounded-2xl bg-white border border-slate-200 p-4"
          data-testid={`privacy-section-${i + 1}`}
        >
          <h2 className="text-base font-semibold text-slate-900 mb-2">{s.title}</h2>
          <div className="text-[14px] text-slate-700 leading-relaxed space-y-2">
            {s.body && s.body.map((p, j) => <p key={j}>{p}</p>)}
            {s.list && (
              <ul className="list-disc pl-5 space-y-1">
                {s.list.map((li, k) => <li key={k}>{li}</li>)}
              </ul>
            )}
            {s.afterList && <p>{s.afterList}</p>}
            {s.list2 && (
              <ul className="list-disc pl-5 space-y-1">
                {s.list2.map((li, k) => <li key={k}>{li}</li>)}
              </ul>
            )}
            {s.definitions && (
              <dl className="space-y-2">
                {s.definitions.map((d, k) => (
                  <div key={k}>
                    <dt className="font-semibold text-slate-800">{d.term}</dt>
                    <dd className="text-slate-700">{d.text}</dd>
                  </div>
                ))}
              </dl>
            )}
            {s.subsections && (
              <div className="space-y-3">
                {s.subsections.map((sub, k) => (
                  <div key={k}>
                    <h3 className="font-semibold text-slate-800 mt-2">{sub.title}</h3>
                    {sub.intro && <p className="mt-1">{sub.intro}</p>}
                    {sub.list && (
                      <ul className="list-disc pl-5 space-y-1 mt-1">
                        {sub.list.map((li, m) => <li key={m}>{li}</li>)}
                      </ul>
                    )}
                    {sub.after && <p className="mt-2">{sub.after}</p>}
                  </div>
                ))}
              </div>
            )}
            {s.footer && s.footer.map((p, j) => <p key={`f${j}`}>{p}</p>)}
          </div>
        </section>
      ))}

      <p className="text-xs text-slate-500 mt-6" data-testid="privacy-stand">
        Stand: August 2026
      </p>
    </div>
  );
}
